import { LOG_PREFIX } from './constants';
export function storageAdapter(log, prefix, wrapper) {
    var keys = [];
    var cache = {};
    var loadPromise;
    var savePromise = Promise.resolve();
    return {
        load: function () {
            return loadPromise || (loadPromise = Promise.resolve().then(function () {
                return wrapper.getItem(prefix);
            }).then(function (storedCache) {
                cache = JSON.parse(storedCache || '{}');
                keys = Object.keys(cache);
            }).catch(function (e) {
                log.error(LOG_PREFIX + 'Error calling wrapper `getItem` method: ' + e);
            }));
        },
        save: function () {
            return savePromise = savePromise.then(function () {
                return Promise.resolve(wrapper.setItem(prefix, JSON.stringify(cache)));
            }).catch(function (e) {
                log.error(LOG_PREFIX + 'Error calling wrapper `setItem` method: ' + e);
            });
        },
        whenSaved: function () {
            return savePromise;
        },
        get length() {
            return keys.length;
        },
        getItem: function (key) {
            return cache[key] || null;
        },
        key: function (index) {
            return keys[index] || null;
        },
        removeItem: function (key) {
            var index = keys.indexOf(key);
            if (index === -1)
                return;
            keys.splice(index, 1);
            delete cache[key];
        },
        setItem: function (key, value) {
            if (keys.indexOf(key) === -1)
                keys.push(key);
            cache[key] = value;
        }
    };
}
